import React, { useState } from 'react';
import { useObtenerNiveles } from '../hooks/EventosBoleteraHook';

type Props = { eventoId: number };

const AforoVentas: React.FC<Props> = ({ eventoId }) => {
  const [reload, setReload] = useState(0);
  const { resumen, loading } = useObtenerNiveles(eventoId, reload);
  const { rows, aforo_max_evento, vendidos_total = 0, en_hold_total = 0 } = resumen;
  const disponiblesTotal = Math.max(0, aforo_max_evento - vendidos_total - en_hold_total);
  const pct = aforo_max_evento > 0 ? Math.round((vendidos_total / aforo_max_evento) * 100) : 0;

  return (
    <div>
      {/* Refresh */}
      <div className="d-flex justify-content-end mb-4">
        <button
          className="btn btn-sm btn-light-primary"
          disabled={loading}
          onClick={() => setReload((r) => r + 1)}
        >
          {loading ? 'Actualizando...' : '↻ Actualizar'}
        </button>
      </div>

      {/* KPIs */}
      <div className="row g-4 mb-8">
        {[
          { label: 'Boletos vendidos',        value: vendidos_total.toLocaleString() },
          { label: 'En reserva (hold activo)', value: en_hold_total.toLocaleString() },
          { label: 'Disponibles',              value: disponiblesTotal.toLocaleString() },
          { label: 'Del aforo total vendido',  value: `${pct}%` },
        ].map((kpi) => (
          <div key={kpi.label} className="col-6 col-lg-3">
            <div className="card card-body py-5 text-center">
              <div className="fs-1 fw-bolder">{kpi.value}</div>
              <div className="text-muted fs-7 mt-1">{kpi.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Tabla por nivel */}
      {rows.length > 0 && (
        <div className="table-responsive">
          <table className="table table-row-dashed align-middle">
            <thead>
              <tr className="fw-bolder text-muted">
                <th>NIVEL</th>
                <th>VENDIDOS</th>
                <th>EN HOLD</th>
                <th>DISPONIBLE</th>
                <th>PROGRESO</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((n) => {
                const vendidos  = n.vendidos ?? 0;
                const enHold    = n.en_hold  ?? 0;
                const disponible = Math.max(0, n.cantidad_boletos - vendidos - enHold);
                const pctNivel  = n.cantidad_boletos > 0
                  ? Math.round((vendidos / n.cantidad_boletos) * 100)
                  : 0;
                return (
                  <tr key={n.id}>
                    <td className="fw-bold">{n.nombre}</td>
                    <td>{vendidos.toLocaleString()}</td>
                    <td>{enHold.toLocaleString()}</td>
                    <td>{disponible.toLocaleString()}</td>
                    <td style={{ width: 160 }}>
                      <div className="progress h-6px">
                        <div className="progress-bar bg-warning" style={{ width: `${pctNivel}%` }} />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export { AforoVentas };
